<template>

<div class="wardrobes" v-if="(builder.quote.totalItemsCost || builder.quote.totalDeliveryCost || builder.quote.totalCost) && builder.quote.valid" :ref="refs['quoteTotals']">

  <div class="wardrobe">
    <div class="wardrobe-inner">

      <div class="wardrobe-main l_p0 l_wrap">

        <div class="wardrobe-cost" v-if="builder.quote.totalItemsCost && builder.quoteNeedsSubtotal && !hasItems">
          <div class="wardrobe-cost-label">Subtotal</div>
          <div class="wardrobe-cost-price" v-if="builder.quoteIsViewable" v-html="builder.displayPriceIncludeGst(builder.quote.totalItems)"></div>
          <div class="wardrobe-cost-price l_blurred" v-else>$00.00</div>
        </div>

        <div class="wardrobe-cost" v-if="builder.quote.totalDiscount != 0">
          <div class="wardrobe-cost-label" style="color:red;" v-html="builder.quote.discountTitle">
          </div>
          <div class="wardrobe-cost-price" style="color:red;" v-if="builder.quoteIsViewable" v-html="builder.displayPriceIncludeGst(builder.quote.totalDiscount)"></div>
          <div class="wardrobe-cost-price l_blurred" style="color:red;" v-else>$00.00</div>
        </div>

        <div class="wardrobe-cost" v-if="builder.quote.totalDeliveryCost && builder.range.handle !== 'kitchens' && builder.range.handle !== 'laundry' && builder.quoteNeedsSubtotal">
          <div class="wardrobe-cost-label" :class="{ 'l_sale' : builder.quote.discountFreeDelivery }" v-if="builder.quote.deliveryType == 'delivery'">Delivery <span v-if="builder.isKlBuilder"><a href="/delivery/" target="_blank">Adelaide metro only</a></span><span v-else-if="builder.quote.postcode">To {{ builder.quote.postcode }}</span></div>
          <div class="wardrobe-cost-label" v-else>Pick Up <span>Collect from Depot (North Plympton)</span></div>
          <div class="wardrobe-cost-price" v-if="builder.quoteIsViewable" :class="{ 'l_sale' : builder.quote.discountFreeDelivery && builder.quote.deliveryType == 'delivery' }">
            <template v-if="builder.quote.discountFreeDelivery && builder.quote.deliveryType == 'delivery'">
              <strike v-html="builder.displayPriceIncludeGst(builder.quote.totalDelivery)"></strike>&nbsp;&nbsp;
              <template v-if="builder.quote.totalDeliveryAfterDiscount != 0">
                <span v-html="builder.displayPriceIncludeGst(builder.quote.totalDeliveryAfterDiscount)"></span>
              </template>
              <template v-else>
                Free
              </template>
            </template>
            <template v-else>
              <span v-if="builder.quoteIsViewable" v-html="builder.displayPriceIncludeGst(builder.quote.totalDelivery)"></span>
              <span v-else>$00.00</span>
            </template>
          </div>
          <div class="wardrobe-cost-price l_blurred" v-else>$00.00</div>
        </div>

        <!-- <div class="wardrobe-cost" v-if="builder.quote.totalTaxCost">
          <div class="wardrobe-cost-label">GST</div>
          <div class="wardrobe-cost-price" v-if="builder.quoteIsViewable" v-html="builder.quote.totalTaxCost"></div>
          <div class="wardrobe-cost-price" v-else>$00.00</div>
        </div> -->

      </div>

      <div class="wardrobe-footer l_p0" v-if="builder.quote.totalCost">

        <div class="wardrobe-cost l_total">
          <div class="wardrobe-cost-label" v-if="isQuote">Quote Total <span>Inc. GST</span></div>
          <div class="wardrobe-cost-label" v-else>Total <span>Inc. GST</span></div>
          <div class="wardrobe-cost-price" v-if="builder.quoteIsViewable" v-html="builder.quote.totalCost"></div>
          <div class="wardrobe-cost-price l_blurred" v-else>$0,000.00</div>
        </div>

      </div>

    </div>
  </div>

</div>

<div class="content-main l_centered l_text-center l_headspace l_min-footspace" v-else>
  <p v-html="builder.messages.quoteIncomplete"></p>
</div>

</template>

<script setup>

import { ref } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const props = defineProps({
  hasItems: {
    type: Boolean,
    default: true
  },
  isQuote: {
    type: Boolean,
    default: true
  }
});

// init refs
let refHandles = [
  'quoteTotals',
];
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});

</script>
